<template>
  <section class="topBlock">
    <el-carousel trigger="click" height="460px">
        <el-carousel-item v-for="banner in banners" :key="banner.id">
            <!-- <h3 class="small">{{ item }}</h3> -->
            <a class="img_btn" @click="open(banner.href)">
                <img :src="imageLocation(banner.src)" :title="banner.name">
            </a>
        </el-carousel-item>
    </el-carousel>
  </section>
</template>
<script>
import {getIndexConfig} from '@/api/index';
export default {
    name: 'Banner',
    data() {
        return {
            banners: []
        }
    },
    created() {
        this.loadData();
    },
    computed: {
        imageLocation(){
            return function (file){
                let imagePath = encodeURI(file);
                return `/files?imagePath=${imagePath}`;
            }
        },
    },
    methods:{
        open(url){
            window.open(url);
        },
        loadData(){
            getIndexConfig().then((res) => {
                this.banners = res.data.images;
            })
        }
    }
}
</script>

<style scoped>
    @import "~@/pages/frontend/assets/css/workroom.css";

    .img_btn{
        cursor: pointer;
    }
</style>